export default "/images/e1ec6d0ff1a922ef0ea4f36670905d88.png";